// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"group-settings_shadow__1CZza","wrapper":"group-settings_wrapper__6JBIB"};